require('./formRuleBuilder.i18n.json');
require('./formRuleBuilder.tpl.html');
require('./formRuleBuilderController.js');
require('./formRuleBuilderRepository.js');

const FormRuleBuilderComponent = {
    templateUrl: '/configuration/formEditor/content/rule/formRuleBuilder/formRuleBuilder.tpl.html',
    controller: 'formRuleBuilderController',
    bindings: {
        formRule: '<',
        canUserManageFormRules: '<'
    }
};

angular.module('ums')
    .component('uiFormRuleBuilder', FormRuleBuilderComponent);
